import {InitData, initUtils, useInitData, Utils} from "@tma.js/sdk-react";
import {Button} from "../Common/Elements/Button";
import {useTranslation} from "react-i18next";
import {webappAddress} from "../../communication/communication";

let globalInitData : InitData | undefined = undefined;
let globalUtils : Utils | undefined = undefined;

export function InviteFriendButton () {
    const utils = initUtils()
    const initData = useInitData()
    const {t} = useTranslation()

    globalInitData = initData!;
    globalUtils = utils!;

    return <Button text={t("inviteAFriend")} onClick={shareRefLink} backgroundColor={"white"} textColor={"black"}/>
}

export function shareRefLink() {
    if (globalInitData === undefined) return;
    if (globalInitData?.user === undefined) return;
    const id = globalInitData.user.id
    const encoded = id.toString(36);
    const url = `${webappAddress}?startapp=${encoded}`
    const data = `https://t.me/share/url?url=${url}`
    globalUtils!.openTelegramLink(data)
}